import { defineStore } from 'pinia';

interface WartungsfensterState {
  istAktiv: boolean;
  meldung: string | null;
  sessionWarningShown: boolean;
}

export const useWartungsfensterStore = defineStore('wartungsfenster', {
  state: (): WartungsfensterState => ({
    istAktiv: false,
    meldung: null,
    sessionWarningShown: false
  }),

  actions: {
    setStatus(aktiv: boolean, meldung: string | null) {
      this.istAktiv = aktiv;
      this.meldung = meldung;

      // Reset warning flag wenn Wartungsfenster nicht mehr aktiv
      if (!aktiv) {
        this.sessionWarningShown = false;
      }
    },

    setWarningShown(shown: boolean) {
      this.sessionWarningShown = shown;
    },

    reset() {
      this.istAktiv = false;
      this.meldung = null;
      this.sessionWarningShown = false;
    }
  }
});
